import { getAvatarInitial } from '@/common/utils';

export function ConversationItem({
  contactName,
  contactPhone,
  lastMessage,
  time,
  unreadCount,
  isActive,
  isWindowActive = true,
  onClick,
  avatarUrl,
  platform = 'whatsapp',
}) {
  const displayName = contactName || contactPhone || '?';
  const initial = getAvatarInitial(displayName);

  const hasUnread = unreadCount > 0;

  return (
    <div
      onClick={onClick}
      className={`
  group relative flex items-center gap-3 px-3 py-3 mx-2 rounded-xl cursor-pointer select-none ${
    platform === 'whatsapp' ? 'wa-inbox-card' : ''
  }
  transition-all duration-150 ease-in-out hover:opacity-90 ${
    isActive
      ? 'bg-[#EAF5EF] border border-primary/20 shadow-xs'
      : hasUnread
        ? 'bg-white border border-gray-200/70 shadow-xs'
        : 'bg-[#F5F5F5] border border-transparent'
  }
  `}
    >
      {/* Active State Indicator */}
      {isActive && (
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-8 bg-primary rounded-r-md" />
      )}

      {/* Avatar */}
      <div className="relative flex-shrink-0">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={displayName}
            className="w-11 h-11 rounded-full object-cover"
          />
        ) : (
          <div
            className={`w-11 h-11 rounded-full flex items-center justify-center font-bold text-base select-none
  ${
    isActive
      ? 'bg-primary/10 text-primary border border-primary/20'
      : hasUnread
        ? 'bg-primary/10 text-primary font-bold border border-primary/20'
        : 'bg-input-background text-text-secondary border border-border-default'
  }
  `}
          >
            {initial}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        {/* Row 1: Name + Time */}
        <div className="flex items-center justify-between gap-2 mb-0.5">
          <h4
            className={`text-sm truncate transition-colors ${
              hasUnread
                ? 'font-bold text-gray-900'
                : 'font-medium text-gray-700'
            }`}
          >
            {displayName}
          </h4>
          <span
            className={`text-[11px] flex-shrink-0 leading-none transition-colors ${
              hasUnread
                ? 'font-bold text-primary'
                : 'text-text-muted font-normal'
            }`}
          >
            {time}
          </span>
        </div>

        {/* Row 2: Last Message + Badges */}
        <div className="flex items-center justify-between gap-2 mt-1">
          <p
            className={`text-xs truncate leading-tight flex-1 transition-colors ${
              hasUnread
                ? 'font-medium text-gray-800'
                : 'text-text-muted font-normal'
            }`}
          >
            {lastMessage}
          </p>

          <div className="flex items-center gap-1.5 flex-shrink-0">
            {/* Window Status Badge */}
            {!isWindowActive ? (
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span>
                <span className="text-xs font-medium text-red-500 whitespace-nowrap">
                  Expired
                </span>
              </div>
            ) : (
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                <span className="text-xs font-medium text-emerald-500 whitespace-nowrap">
                  Active
                </span>
              </div>
            )}

            {/* Unread Count Badge */}
            {unreadCount > 0 && (
              <span className="min-w-[16px] h-4 px-1 text-[9px] font-bold text-white bg-primary rounded-full flex items-center justify-center leading-none ml-1">
                {unreadCount > 999 ? '99+' : unreadCount}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
